import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import {  AudioManager} from "../../AudioManager";
import { PickBonusElement } from "../PickBonus/PickBonusElement";


// namespace SlotGames {
    export class IcyFresh_2Screen extends SlotGameType1_2Screen {
        //protected panelFactory: IPanelFactory = new IcyFreshPanelFactory();
        
        protected override helpFactory: IHelpFactory = new IcyFreshHelpFactory();


        //SEND COLOR FOR RSA 
        protected override color: RewardColor =
            {
                color: "#0A7CBF",
                coloroutherStroke: "black",
                colorinnerStroke: "#031333",
            }

        //LED COLOR
        protected override ColorLed: string = "0,25,255\n";

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "IcyFresh");
            this.spinnableReelsParams.topBorderWidth = 10;
            this.spinnableReelsParams.bottomBorderWidth = 6;
        }

        // public PrepareFont(resourceManager: ResourceManager) {
        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", "." + this.resid.ScopedResourceName("font")));
        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
        // }
    }



    //Panel Colorized
    class IcyFreshPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new IcyFreshPanel(params);
        }
    }

    class IcyFreshPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, rgb(15, 224, 242),transparent ) 0 10 100%",
            };

            return color;
        }

    }

    //Help Colorized
    class IcyFreshHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new IcyFreshHelp(params);
        }
    }

    class IcyFreshHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }



    class IcyFreshPickBonusElement extends PickBonusElement {
        public override AwardElemePrepare() {
            super.AwardElemePrepare();
        }
    }


// }
